import { Logo } from "./logo"
import  { Navigation }  from "./navigation";
import Link from "next/link";
import {EnvBadge} from "@/components/custom/header/EnvBadge";

interface TopbarProps {
    navAccountTranslation: {
        label: string;
        tooltip: string;
    },
    navBookmarksTranslation: {
        label: string;
        tooltip: string;
    },
    navLanguageTranslation: {
        tooltip: string;
    }
    langSelectorOpen: boolean,
    setLangSelectorOpen: (langSelector: boolean) => void,
    locale: string,
    env: string,
    entraIdIssuer: string
}

export function Topbar({ navAccountTranslation, navBookmarksTranslation, langSelectorOpen, navLanguageTranslation, setLangSelectorOpen, locale, env, entraIdIssuer }: TopbarProps) {
    return (
        <div className='header__section w-full bg-primary py-3 text-sm text-primary-foreground'>
            <div className='container'>
                <div className='flex h-[42px] flex-row items-center justify-between'>
                    <div className='logo h-full hidden md:block'>
                        <Link href='/' className='flex h-full flex-row items-start'>
                            <Logo/>
                            <EnvBadge env={env} />
                        </Link>
                    </div>
                    <p className={"hidden md:block"}>PRODUCT INFORMATION SYSTEM</p>
                    <Navigation
                        langSelectorOpen={langSelectorOpen}
                        setLangSelectorOpen={setLangSelectorOpen}
                        navAccountTranslation={navAccountTranslation}
                        navBookmarksTranslation={navBookmarksTranslation}
                        navLanguageTranslation={navLanguageTranslation}
                        locale={locale}
                        env={env}
                        entraIdIssuer={entraIdIssuer}
                    />
                </div>
            </div>
        </div>
    )
}
